import { DualPrice, Price, SinglePrice, formatPrice } from 'modules/proposals';
import React from 'react';

interface Props {
  currency: string;
  pricePerUnit: number;
  exchangeRate?: number;
  dualCurrency?: string;
  ISOCountry?: string;
}

export const UnitPublicServiceSegmentCardPrice: React.FC<Props> = ({
  currency,
  pricePerUnit,
  exchangeRate,
  dualCurrency = 'eur',
  ISOCountry,
}) => (
  <Price
    currency={currency}
    dualCurrency={dualCurrency}
    customExchangeRate={exchangeRate}
    dualPriceElement={
      <DualPrice>
        <p className="t-eta">
          {formatPrice(pricePerUnit, currency, ISOCountry)}
        </p>
        {exchangeRate && (
          <p className="o-60 text--xxs__responsive">
            {formatPrice(pricePerUnit * exchangeRate, dualCurrency, ISOCountry)}
          </p>
        )}
      </DualPrice>
    }
    singlePriceElement={
      <SinglePrice className="t-eta">
        {formatPrice(pricePerUnit, currency, ISOCountry)}
      </SinglePrice>
    }
  />
);
